import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./plugins/smoothScroll";
import VueGtag from "vue-gtag";

// Import Amplify Modules, Plugins, and aws exports file
import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import { AmazonAIPredictionsProvider } from "@aws-amplify/predictions";
import awsconfig from "./aws-exports";

// Configure Amplify in project
Amplify.configure(awsconfig);
Amplify.addPluggable(new AmazonAIPredictionsProvider());

// Configure vue to use plugins and modules
Vue.use(AmplifyPlugin, AmplifyModules);

Vue.use(VueGtag, {
  config: { id: "UA-159044587-1" }
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
